export default {
    create_template_edit: "Edit Template",
    create_template_create: "Create Template",
    create_template_create_message: "The template has been created",
    create_template_edit_message: "The template has been edited",
    create_template_name: "Name",
    create_template_language: "Language",
    create_template_module_code: "Module Code",
    create_template_save: "Save",
    create_template_no_changes_to_save: "No changes to save",
    create_template_save_new_template: "Save as new template",
    create_template_same_name: "A template with the same name already exists",



    create_template_confirm_to_continue: "Confirm to continue",
    create_template_confirm_message_save: "You have pending changes to save, do you want to continue without saving?",
    create_template_continue: "Continue",
    create_template_confirm_to_save: "Confirm To Save",
    create_template_save_cloud_login_page_for: "Are you sure you want to save the current cloud login page for",
    create_template_confirm: "Confirm",
}


